import React from 'react';
import { useSelector } from 'react-redux';

import Information from 'views/Product/EditProduct/Settings/Sections/Information';
import UserDetails from 'views/Product/EditProduct/Settings/Sections/UserDetails';
import SkidataDetails from 'views/Product/EditProduct/Settings/Sections/SkidataDetails';
import MaintenanceTime from 'views/Product/EditProduct/Settings/Sections/MaintenanceTime';
import AdditionalProducts from 'views/Product/EditProduct/Settings/Sections/AdditionalProducts';
import Online from 'views/Product/EditProduct/Settings/Sections/Online';
import Integrations from 'views/Product/EditProduct/Settings/Sections/Integrations';
import Deposit from 'views/Product/EditProduct/Settings/Sections/Deposit';
import { isLiftTicketProduct } from 'common/utils/liftTicketUtils';
import * as ActiveProductSelectors from 'selectors/ActiveProductSelectors';
import SalesChannels from './Sections/SalesChannels';
import Stores from './Sections/Stores';
import Segments from './Sections/Segments';
import HasFeature from 'components/features/HasFeature';

// TODO: This is fully functional, but apparently confusing for clients as the info is not
// used anywhere. Re-add when that is the case.
//
// import AdditionalDetails from 'views/Product/EditProduct/Settings/Sections/AdditionalDetails';

const Settings = () => {
	const product = useSelector(ActiveProductSelectors.productDataWithChanges);
	return (
		<>
			{!isLiftTicketProduct(product) && <AdditionalProducts />}
			{/**
			 * TODO: Add correct features here
			 */}
			<HasFeature requiredFeature={[]}>
				<SalesChannels />
				<Stores />
				<Segments />
			</HasFeature>
			{isLiftTicketProduct(product) && <SkidataDetails />}
			{!isLiftTicketProduct(product) && (
				<>
					<Deposit />
					<Information />
					<UserDetails />
					<Online />
					<Integrations />
					<MaintenanceTime />
				</>
			)}

			{/* <AdditionalDetails /> */}
		</>
	);
};

export default Settings;
